export enum FollowUpType {
    DYNAMIC_FOLLOW_UP = "DynamicFollowUp",
    STATIC_FOLLOW_UP = "StaticFollowUp"
}

export enum OtherFollowUpType {
    DYNAMIC= "Dynamic",
    STATIC = "Static"
}
